// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-m__title__3qLG2","text":"styles-m__text__3zmt3"};